export const CART_SCREEN_HEADER = "Order summary";
export const EMPTY_CART_SCREEN = {
    heading: "Good food is always cooking",
    description: "You haven't placed any orders. Add something from the menu",
    ctaText: "Start ordering",
    img: "portal/static-assets/hcms/dineout/qr/empty_cart.png",
};
